'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import type { SearchScope } from './constants';
import { EXIT_DURATION, FADE_DURATION } from './motion';
import { RecentSearchList } from './RecentSearchList';
import { SearchBar } from './SearchBar';
interface MobileSearchOverlayProps {
  isOpen: boolean;
  keyword: string;
  scope?: SearchScope;
  recentKeywords: string[];
  onClose: () => void;
  onSearch: (keyword: string) => void;
  onSelectRecent: (keyword: string) => void;
  onRemoveRecent: (keyword: string) => void;
  onClearRecent: () => void;
}

//* 뒤로가기용 히스토리 엔트리는 여는 쪽(SearchPageHeader)이 소유한다 — useOverlayHistory 계약.
export function MobileSearchOverlay(t0) {
  const $ = _c(13);
  const {
    isOpen,
    keyword,
    scope,
    recentKeywords,
    onClose,
    onSearch,
    onSelectRecent,
    onRemoveRecent,
    onClearRecent
  } = t0;
  const shouldReduceMotion = useReducedMotion();
  let t1;
  if ($[0] !== isOpen || $[1] !== keyword || $[2] !== onClearRecent || $[3] !== onClose || $[4] !== onRemoveRecent || $[5] !== onSearch || $[6] !== onSelectRecent || $[7] !== recentKeywords || $[8] !== scope || $[9] !== shouldReduceMotion) {
    t1 = isOpen && <motion.div key="mobile-search-layer" role="dialog" aria-modal="true" aria-label={"\uAC80\uC0C9\uC5B4 \uC785\uB825"} initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      transition: {
        duration: shouldReduceMotion ? 0 : FADE_DURATION,
        ease: "easeOut"
      }
    }} exit={{
      opacity: 0,
      transition: {
        duration: shouldReduceMotion ? 0 : EXIT_DURATION,
        ease: "easeIn"
      }
    }} className="fixed inset-0 z-50 flex flex-col overflow-y-auto overscroll-contain bg-Gray-white"><SearchBar keyword={keyword} shouldAutoFocus={true} sticky={false} scope={scope} onBack={onClose} onSearch={onSearch} /><RecentSearchList keywords={recentKeywords} onSelect={onSelectRecent} onRemove={onRemoveRecent} onClearAll={onClearRecent} /></motion.div>;
    $[0] = isOpen;
    $[1] = keyword;
    $[2] = onClearRecent;
    $[3] = onClose;
    $[4] = onRemoveRecent;
    $[5] = onSearch;
    $[6] = onSelectRecent;
    $[7] = recentKeywords;
    $[8] = scope;
    $[9] = shouldReduceMotion;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}